import palette from '../palette';

export default {
  highlight: {
    backgroundColor: { color: palette.primary.main }
  }
};